import { render, staticRenderFns } from "./PlatformRegulationsPage.vue?vue&type=template&id=22c577b5&"
import script from "./PlatformRegulationsPage.vue?vue&type=script&lang=js&"
export * from "./PlatformRegulationsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports